import { render } from "./UnconditionalBankDetailsStep.vue?vue&type=template&id=36ccebf4&scoped=true"
import script from "./UnconditionalBankDetailsStep.vue?vue&type=script&lang=js"
export * from "./UnconditionalBankDetailsStep.vue?vue&type=script&lang=js"

import "./UnconditionalBankDetailsStep.vue?vue&type=style&index=0&id=36ccebf4&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ccebf4"]])

export default __exports__